import { hasStoredBiometricSession } from '@supply-mover-2-0/web-ui';
import * as portalAuthService from '../services/portalAuthService';
import { usePortalAuthStore } from '../stores/portalAuthStore';

/**
 * PD-16414 — the storefront's one sign-out path, used by the Sign Out menu
 * items and by the idle sign-out.
 *
 * Local state is cleared first and synchronously, before any await: the
 * callers navigate and open the sign-in dialog right after calling this,
 * other tabs follow through the storage event, and no request goes out with
 * a token that is being revoked.
 *
 * The server session is then revoked (best effort) unless `revoke` is false,
 * which is for a tab following another tab's sign-out, or unless this device
 * has Face ID / fingerprint sign-in enrolled. That stored credential is the
 * session's refresh token, kept behind the OS biometric gate; revoking it
 * would break "Sign in with Face ID", which counts as signing back in. On the
 * web there is no such credential, so the session always ends on the server.
 */
export async function signOutPortal(options: {
	revoke: boolean;
}): Promise<void> {
	const { token, refreshToken } = usePortalAuthStore.getState();
	usePortalAuthStore.getState().reset();

	if (!options.revoke || (token == null && refreshToken == null)) {
		return;
	}
	if (await hasStoredBiometricSession()) {
		return;
	}
	try {
		await portalAuthService.logout(token, refreshToken);
	} catch (error) {
		// The local sign-out already happened; a failed revoke leaves the
		// refresh token to expire on its own schedule.
		console.debug('[portalSignOut] Server revoke failed', error);
	}
}
